import { Alert, Backdrop, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Snackbar } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { useState } from "react";
import { deleteProfile } from "./DeleteProfileButton.services";
import { useMsal } from "@azure/msal-react";

export const DeleteProfileButton = () => {
    const [open, setOpen] = useState(false);
    const [loader, setLoader] = useState(false);
    const [snackbar, setSnackbar] = useState(false);
    const [deleted, setDeleted] = useState(false);
    const [severity, setSeverity] = useState<'success' | 'error'>('error');
    const { instance, accounts } = useMsal();

    const openDeleteDialog = () => {
        setOpen(true);
    };

    const closeDeleteDialog = () => {
        setOpen(false);
    };

    async function callDeleteProfileApi() {
        try {
            var tokenClaims = accounts[0].idTokenClaims;
            var userId = tokenClaims?.sub;
            await deleteProfile(userId);
            setDeleted(true);
            setSeverity('success');
            setSnackbar(true);
        } catch (error) {
            setSeverity('error');
        }
    }

    const deleteProfileHandler = async () => {
        setOpen(false);
        setLoader(true);
        await callDeleteProfileApi();
        setLoader(false);
    }

    const handleSnackbar = () => {
        if (deleted) {
            instance.logoutRedirect({
                postLogoutRedirectUri: "/",
            });
        }
        setSnackbar(false);
    }

    return <>
        <Button variant="outlined" startIcon={<Delete />} onClick={openDeleteDialog}>
            Delete Account
        </Button>
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loader}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
        <Dialog
            open={open}
            onClose={closeDeleteDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {"Do you want to delete your account?"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    This action is irreversible, All your data and account will be deleted.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDeleteDialog}>No</Button>
                <Button onClick={deleteProfileHandler} autoFocus>
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbar} autoHideDuration={4000} onClose={handleSnackbar}>
            <Alert
                onClose={handleSnackbar}
                severity={severity}
                variant="filled"
                sx={{ width: '100%' }}
            >
                {deleted ? 'Account deleted successfully!' : 'Something went wrong, Please try again.'}
            </Alert>
        </Snackbar>
    </>;
}